import { AuxiliumComponent } from "../auxilium-component";

export default class Select extends AuxiliumComponent {
	static observable = ["value", "description", "label", "orientation", "helper-text", "secondary-label"];
	static observableBooleans = ["required"];

	#Mappers = {};

	constructor() {
		super();

		this.readonly = this.getAttribute("readonly") ?? false;

		this.#Mappers = {
			name: this.getAttribute("name"),
			autofocus: this.hasAttribute("focus"),
			autocomplete: this.getAttribute("autocomplete"),
			readonly: this.readonly,
			required: this.hasAttribute("required"),
			tabIndex: this.getAttribute("tabindex") ?? ""
		};

		Object.keys(this.#Mappers).forEach(key => this[key] = this.#Mappers[key]);
	}

	parsedCallback() {
		const select = document.createElementWithContents("select", [...this.querySelectorAll(":scope > chip-option")].map(x => document.createElementWithContents("option", x, { value: x.value })), {
			id: this.identifier,
			onchange: () => {
				this.value = select.value
				this.reportValidity();
			}
		});

		if (this.label || this.secondaryLabel) {
			const label = document.createElementWithContents("label", this.label, {
				htmlFor: this.identifier,
				className: "input-field__label"
			});

			if (this.secondaryLabel) { label.appendChild(document.createElementWithContents("span", this.secondaryLabel, { className: "input-field__label--secondary" })); }

			this.appendChild(label);
		} else if (this.description) {
			select.ariaLabel = this.description;
		}

		Object.keys(this.#Mappers).filter(x => this.#Mappers[x])
			.forEach(key => select.setAttribute(key, this.#Mappers[key] === true ? "" : this.#Mappers[key]));

		if (this.value) { select.value = this.value; }
		else { this.value = select.value; }

		this.appendChild(document.createElementWithContents("div", select, { className: "select__wrapper" }));

		if (this.helperText) {
			const helperTextMethod = Browser.GetFlavour() === "gov" ? "beforebegin" : "afterend";

			select.insertAdjacentElement(helperTextMethod, document.createElementWithContents("div", this.helperText, {
				className: "input-field__helper-text"
			}));
		}
	}

	checkValidity() {
		return this.querySelector("select")?.checkValidity() ?? false;
	}

	setInvalid(message) {
		const select = this.querySelector("select"),
			msgElement = document.createElementWithContents("div", message, { className: "input-field__validation-error" });

		if (!this.disableMessages) {
			if (Browser.GetFlavour() === "gov") {
				this.querySelector(".select__wrapper").insertAdjacentElement("beforebegin", msgElement);
			} else {
				this.appendChild(msgElement);
			}
		}

		select.classList.add("input-field__invalid");

		this.querySelectorAll(".input__bound").forEach(x => x.classList.add("input-field__invalid"));
	}

	reportValidity() {
		const select = this.querySelector("select"),
			validity = this.checkValidity();

		this.querySelector(".input-field__validation-error")?.remove();
		this.querySelectorAll(".input-field__invalid").forEach(x => x.removeClass("input-field__invalid"));

		if (!validity) {
			this.setInvalid(select.validationMessage || this.validationMessage);
		}

		return validity;
	}

	attributeChanged(name, _, newValue) {
		switch (name) {
			case "value":
				this.querySelector("select").value = newValue;
				break;
			case "required":
				{
					const select = this.querySelector("select");

					if (select) {
						select.required = this.IsAttributeValueTrue(newValue);
					}
				}
				break;
			case "label":
				{
					const label = this.querySelector(".input-field__label");

					if (label) {
						label.textContent = newValue;
					}
				}
				break;
			case "description":
				{
					const select = this.querySelector("select");

					if (select && !document.querySelector(`[for='${select.id}']`)) {
						select.ariaLabel = newValue;
					}
				}
				break;
		}
	}
}
